import { useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetFormsDto } from "src/http/types";
import { useAccessToken } from "src/http/use-access-token";
import { queryKeys } from "../queryKeys";

const useGetFormsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getFormsRequest(): Promise<GetFormsDto> {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/forms`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getFormsRequest };
};

const useGetForms = () => {
  const { getFormsRequest } = useGetFormsRequest();

  return useQuery({
    queryKey: queryKeys.forms.getForms(),
    queryFn: getFormsRequest,
  });
};

export { useGetForms };
